:host {
  font-family: var(--font-sans);
  display: block;
}

button#new {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  width: var(--size-10);
  height: var(--size-10);
  background-color: var(--pos-primary-color);
  color: var(--pos-primary-text-color);
  font-size: var(--scale-6);
  border-radius: var(--radius-xs);
  padding: var(--size-2);
}

button#new:hover,
button#new:focus {
  outline: none;
  filter: brightness(110%);
  box-shadow: var(--shadow-sm);
}

pos-new-thing-form {
  margin: var(--scale-3);
}
